module.exports = __webpack_public_path__ + "img/page-speed.88102c29.svg";